<template>
  <v-card color="transparent" flat>
    <v-card-title>Admin Dashboard</v-card-title>

    <v-card-text class="pa-0">
      <v-row>
        <v-col cols="6">
          <v-row>
            <v-col cols="12">
              <tasks-card
                :tasks="unassignedUrgentTasks"
                title="Unassigned - Urgent tasks"
              />
            </v-col>

            <v-col cols="12">
              <tasks-card
                :tasks="userCreatedTasks"
                title="Your created tasks"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="6">
          <v-row>
            <v-col cols="12">
              <tasks-card :tasks="userUrgentTasks" title="Your urgent tasks" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <tasks-card :tasks="userOtherTasks" title="Your other tasks" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import TasksCard from '@/components/tasks/common/TasksCard'
export default {
  name: 'AdminDashboard',
  props: {
    tasks: {
      type: Array,
      required: true
    },
    loading: {
      type: Object,
      required: true
    }
  },
  components: {
    TasksCard
  },
  computed: {
    unassignedUrgentTasks() {
      return this.tasks.filter(
        task => !task.completed && !task.assigned_to && task.urgent
      )
    },
    userCreatedTasks() {
      return this.tasks.filter(
        task =>
          !task.completed &&
          task.created_by &&
          task.created_by.id == this.$authUser.id
      )
    },
    userUrgentTasks() {
      return this.tasks.filter(
        task =>
          !task.completed &&
          task.assigned_to &&
          task.assigned_to.id == this.$authUser.id &&
          task.urgent
      )
    },
    userOtherTasks() {
      return this.tasks.filter(
        task =>
          !task.completed &&
          task.assigned_to &&
          task.assigned_to.id == this.$authUser.id &&
          !task.urgent
      )
    }
  }
}
</script>
